<script setup>

import {useI18n} from "vue-i18n";

const { locale } = useI18n();

</script>
<template>
  <div :key="locale" class="max-w-8xl lg:max-w-full mx-auto px-6 lg:px-8">
    <slot></slot>
  </div>
</template>



<style lang="scss" scoped></style>
